<template>
    <td>
        <v-text-field
            class="text-center"
            :model-value="service.availableQuantity"
            flat
            hide-details
            min-width="45"
            type="number"
            hide-spin-buttons
            @update:model-value="changeRoomAvailability"
        />
    </td>
</template>

<script setup lang="ts">
    const props = defineProps<{
        date: string
        service: any
    }>()

    const emit = defineEmits<{
        (e: 'update', payload: any): void
    }>()

    const changeRoomAvailability = (value: number | string): void => {
        emit('update', {
            dateFrom: props.date,
            dateTo: props.date,
            categoryId: props.service.categoryId,
            serviceId: props.service.serviceId,
            operation: 'SET',
            dayOfWeek: [true, true, true, true, true, true, true],
            amount: value,
        })
    }
</script>

<style scoped lang="scss">
    :deep(.v-field__input) {
        padding: 5px;
    }
</style>
